import List from '../../../components/People/Salaries/List'
import PageTitle from '../../../elements/PageTitle'
import {Breadcrumb, Card, Layout, Row} from 'antd'
import React, {Fragment} from 'react'

const {Content} = Layout

function Salaries(props) {
  return (
    <Fragment>
      <Content style={{margin: '0px 0px'}}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/people/dashboard">People</Breadcrumb.Item>
              <Breadcrumb.Item>Salaries</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Salaries'}
              subtitle={'List of salaries'}
              color={'#FF6138'}
              iconType={'read'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{padding: 10}}>
          <Card>
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Salaries.propTypes = {}
Salaries.defaultProps = {}

export default Salaries
